<template>
  <div>
    <div class="columns is-multiline">
      <!-- <div class="column is-full">
        <span><b>Ciudad</b></span>
        <p><b-icon icon="city-variant" size="is-small"></b-icon> {{location}}</p>
      </div> -->
      <div class="column">
        <span><b>Dirección</b></span>
        <p><b-icon icon="city-variant" size="is-small"></b-icon> {{location}}</p>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <span><b>Email</b></span>
        <p><b-icon icon="email" size="is-small"></b-icon> {{email}}</p>
      </div>
      <div class="column">
        <span><b>Teléfono</b></span>
        <p><b-icon icon="cellphone-iphone" size="is-small"></b-icon> {{phone}}</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span><b>Nacimiento</b></span>
        <p><b-icon icon="calendar" size="is-small"></b-icon> {{ birthDate }}</p>
      </div>
      <div class="column">
        <span><b>Edad</b></span>
        <p><b-icon icon="cake-variant" size="is-small"></b-icon> {{age}}</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span><b>Género</b></span>
        <p><b-icon :icon="genderIcon" size="is-small"></b-icon> {{gender}}</p>
      </div>
      <div class="column">
        <span><b>Estado</b></span>
        <p>
          <b-tag type="is-info" v-if="rider.user_status_id === 1">Activo</b-tag>
          <b-tag type="is-dark" v-else>Inactivo</b-tag>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rider: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      noInfo: 'S/I'
    }
  },
  computed: {
    location () {
      return this.rider.person && this.rider.person.location ? this.rider.person.location : this.noInfo
    },
    address () {
      return this.rider.person && this.rider.person.address ? this.rider.person.address : this.noInfo
    },
    email () {
      return this.rider.email ? this.rider.email : this.noInfo
    },
    phone () {
      return this.rider.person && this.rider.person.phone ? this.rider.person.phone : this.noInfo
    },
    birthDate () {
      return this.rider.person && this.rider.person.birth_date ? this.moment(this.rider.person.birth_date, 'YYYY-MM-DD').format('L') : this.noInfo
    },
    age () {
      let years = this.rider.person ? this.moment().diff(this.rider.person.birth_date, 'years') : ''
      return years
    },
    genderIcon () {
      let icon = ''
      if (this.rider.person) {
        if (this.rider.person.gender === 'M') {
          icon = 'gender-male'
        } else if (this.rider.person.gender === 'F') {
          icon = 'gender-female'
        }
      }
      return icon
    },
    gender () {
      let gender = this.noInfo
      if (this.rider.person) {
        if (this.rider.person.gender === 'M') {
          gender = 'Masculino'
        } else if (this.rider.person.gender === 'F') {
          gender = 'Femenino'
        }
      }
      return gender
    }
  }
}
</script>
